import { useEffect, useRef, useState } from "react";
import {
  getHolidays,
  mapHolidaysToDateKeys,
} from "../api/holidays";
import { useAppDispatch } from "../store";

const holidayCache = new Map<number, string[]>();

export function useHolidayDateKeys(year: number | null | undefined) {
  const dispatch = useAppDispatch();
  const [holidayDates, setHolidayDates] = useState<string[]>(() =>
    year != null ? holidayCache.get(year) ?? [] : []
  );
  const requestYearRef = useRef<number | null>(null);

  useEffect(() => {
    if (year == null || !Number.isFinite(year)) {
      setHolidayDates([]);
      return;
    }

    const cached = holidayCache.get(year);
    if (cached) {
      setHolidayDates(cached);
      return;
    }

    let cancelled = false;
    requestYearRef.current = year;

    (async () => {
      try {
        const response = await dispatch(getHolidays({ year }));
        if (cancelled || requestYearRef.current !== year) return;

        const keys = mapHolidaysToDateKeys(response?.data ?? [], year);
        holidayCache.set(year, keys);
        setHolidayDates(keys);
      } catch {
        if (!cancelled && requestYearRef.current === year) {
          setHolidayDates([]);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [dispatch, year]);

  return holidayDates;
}
